import React from "react";

import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper";
import StoryblokLink from "../../internal/storyblokLink/StoryblokLink";
import { linkedinShare, linkShare } from "../../../utils/socialShare";

import LinkIcon from "../../../../static/images/linkWhite.svg"
import LinkedinIcon from "../../../../static/images/LinkedinWhite.svg"

import "./socialShare.scss"

const SocialShare = ({blok, story}) => {

    return ( 
        <WidgetWrapper blok={blok}>
            <div className="socialShareWidget">
                <div className="container socialContainer">
                    <div className="row socialRow">
                        <div className={`socialHeadLine`}>
                            <h3>{blok.headline ? blok.headline : "Share"}</h3>
                        </div>
                        <div className={`socialLinks col-sm-6`}>
                            {!blok.hide_linkedin ? <a href={linkedinShare(story.story)} target="_blank" className="socialIcon"><img src={LinkedinIcon}/></a>: null}
                            {!blok.hide_email ? <a href={linkShare(story.story)} target="_blank" className="socialIcon"><img src={LinkIcon}/></a>: null}
                            
                        </div>
                        <div className={`socialCta col-sm-3`}>
                            <StoryblokLink text={blok.button_text} withClass={`btn transparent-white`} SBLinkData={blok.button_link} />
                        </div>
                    </div>
                </div>
            </div>
        </WidgetWrapper>
     );
}
 
export default SocialShare;